import e from "./chunk958.js";
import n from "./chunk920.js";
function i(t) {
  return n("MuiSnackbarContent", t);
}
e("MuiSnackbarContent", ["root", "message", "action"]);
export {
  i as getSnackbarContentUtilityClass
};
